module.exports = __webpack_public_path__ + "img/logo.9771e2d7.svg";